import { DRIVER_TYPE as DRIVER_TYPE_FIELD } from ".";
import { ALL } from "../strings";
import {
  DRIVER_TYPE_NAMES,
  AGENCY_DRIVER_TYPE,
  COURIER_DRIVER_TYPE,
  ODF_DRIVER_TYPE,
  DR_DRIVER_TYPE,
  EMPLOYED_DRIVER_TYPE,
  EMPLOYED_7_5T_DRIVER_TYPE,
  CHOICE_DRIVER_TYPE,
  HOME_COURIER_DRIVER_TYPE,
  ROBOT_DRIVER_TYPE,
} from "../../consts/driverTypes";

const OPTIONS = {
  0: { label: ALL },
  1: {
    label: DRIVER_TYPE_NAMES[AGENCY_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: AGENCY_DRIVER_TYPE,
    },
  },
  2: {
    label: DRIVER_TYPE_NAMES[COURIER_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: COURIER_DRIVER_TYPE,
    },
  },
  3: {
    label: DRIVER_TYPE_NAMES[ODF_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: ODF_DRIVER_TYPE,
    },
  },
  4: {
    label: DRIVER_TYPE_NAMES[DR_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: DR_DRIVER_TYPE,
    },
  },
  5: {
    label: DRIVER_TYPE_NAMES[EMPLOYED_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: EMPLOYED_DRIVER_TYPE,
    },
  },
  6: {
    label: DRIVER_TYPE_NAMES[EMPLOYED_7_5T_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: EMPLOYED_7_5T_DRIVER_TYPE,
    },
  },
  7: {
    label: DRIVER_TYPE_NAMES[CHOICE_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: CHOICE_DRIVER_TYPE,
    },
  },
  8: {
    label: DRIVER_TYPE_NAMES[HOME_COURIER_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: HOME_COURIER_DRIVER_TYPE,
    },
  },
  9: {
    label: DRIVER_TYPE_NAMES[ROBOT_DRIVER_TYPE],
    functionParameters: {
      field: "driverType",
      value: ROBOT_DRIVER_TYPE,
    },
  },
};

export const DRIVER_TYPE = {
  title: "Driver Type",
  field: DRIVER_TYPE_FIELD,
  values: Object.keys(OPTIONS).map((option) => ({
    value: option,
    ...OPTIONS[option],
  })),
  filterCallback: ({ driver, field, value }) => driver[field] === value,
  volumeOverlayRequired: false,
};
